import { createContext, useContext, useState, useEffect, type ReactNode } from 'react'
import type { Lang } from '../i18n'
import { APP_CONTEXT_INITIAL_STATE, type AppContextType } from './app-constants'

export const AppContext = createContext<AppContextType>({
  ...APP_CONTEXT_INITIAL_STATE,
})

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLang] = useState<Lang>('ar')
  const [dark, setDark] = useState(false)

  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = lang
  }, [lang])

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
  }, [dark])

  return (
    <AppContext.Provider value={{ lang, setLang, dark, setDark }}>
      {children}
    </AppContext.Provider>
  )
}

export const useApp = () => useContext(AppContext)